import React from 'react'
import { FormattedMessage } from 'react-intl'
import { accentuate } from '../'
import { Section, Heading, ExternalLinkBlock } from '../s'
import Paragraph from 'components/typography/paragraph'
import { OrderedList, ListItem } from 'components/list'

const SlackHowToUse = ({ data }) => (
    <Section>
        <Heading>
            <FormattedMessage
                id="integration_heading_how_to_use"
                defaultMessage="How to use" />
        </Heading>
        <Paragraph>
            <FormattedMessage
                id="integration_preamble_how_to_use"
                defaultMessage="Get started quickly by following these steps:" />
        </Paragraph>
        <OrderedList className="decimals">
            <ListItem>
                <FormattedMessage
                    id="integration_instruction_connect"
                    defaultMessage="Click the <accent>Set up</accent> button, and accept Huma’s Terms and Conditions"
                    values={{ accent: accentuate }} />
            </ListItem>
            <ListItem>
                <FormattedMessage
                    id="integration_slack_how_to_use_step_2"
                    defaultMessage="You will be sent to Slack and asked to authorize the connection to your Slack workspace" />
            </ListItem>
            <ListItem>
                <FormattedMessage
                    id="integration_slack_how_to_use_step_3"
                    defaultMessage="Once a connection is successfully established, the ‘Huma HR’ Slack app (the notification bot) will be added to your Slack workspace" />
            </ListItem>
        </OrderedList>
        <ExternalLinkBlock href={data.knowledgebaseUrl}>
            <FormattedMessage
                id="integration_slack_link_knowledgebase"
                defaultMessage="Using the Slack integration" />
        </ExternalLinkBlock>
    </Section>
)

export default SlackHowToUse